const CodingJuniorWinnersList: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <section className="mb-8">
                <p className="mb-2">
                    Kompetisi Coding Python Junior dalam ajang <b>Indonesia Innovative Technology Challenge (IIT Challenge) 2024</b> telah sukses menampilkan bakat-bakat muda di bidang pemrograman. Kategori ini dirancang untuk menguji kemampuan logika, algoritma, dan problem-solving peserta menggunakan bahasa Python.
                </p>

                <p className="mb-2">Setelah persaingan ketat, berikut para pemenang yang berhasil mencatatkan prestasi gemilang:</p>

                <p className='mb-3'><b>🏆 Pemenang Coding Python Junior 2024</b></p>
                <ul className="list-disc pl-6 mb-4">
                    <li>🥇 Juara 1: Raphael Wenzhou Pronto (SMP Kristen IPEKA Puri)</li>
                    <li>🥈 Juara 2: Jefferson Matthew Adidjaja (SMPK 2 Penabur)</li>
                    <li>🥉 Juara 3: Samuel Keith Lint (SMP Kristen IPEKA Puri)</li>
                </ul>

                <p className="mb-4 font-semibold">Hadiah & Manfaat untuk Para Pemenang:</p>

                <p className='mb-3'>Selain medali dan sertifikat penghargaan, para pemenang berhak mendapatkan <b>fasilitas eksklusif</b> untuk mendukung pengembangan skill teknologi mereka:</p>
                <ul className="list-disc pl-6 mb-3">
                    <li>✅ Software Programming Bootcamp (2 Bulan) – Senilai Rp 26.550.000</li>
                    <li>✅ Robotic Race Workshop – Persiapan untuk WIT Challenge 2024</li>
                    <li>✅ Software Programming Workshop – Persiapan untuk WIT Challenge 2024</li>
                    <li>✅ Subsidi Biaya Pendaftaran WIT Challenge 2024</li>
                </ul>
                <p className='mb-4'>Hadiah ini dirancang untuk memberikan <b>pengalaman belajar intensif</b> dan kesempatan bersaing di kompetisi teknologi tingkat nasional.</p>

                <p className='mb-3 font-semibold'>Mengapa Kompetisi Ini Berharga?</p>
                <ul className="list-disc pl-6 mb-4">
                    <li><b>Meningkatkan Kemampuan Logika</b> – Peserta belajar menyusun solusi coding yang efisien.</li>
                    <li><b>Membentuk Mental Kompetitif</b> – Berani menghadapi tantangan di bawah tekanan waktu.</li>
                    <li><b>Jaringan & Peluang Karir</b> – Workshop dan bootcamp membuka pintu kolaborasi dengan ahli teknologi.</li>
                </ul>

                <p className='mb-2 font-semibold'>Ayo Ikuti Jejak Mereka!</p>
                <p className="mb-2">Kesuksesan para pemenang membuktikan bahwa <b>usia bukan penghalang untuk menguasai teknologi.</b> Bagi yang ingin mengikuti jejak mereka, persiapkan diri dari sekarang!</p>

                <p className='mb-2 font-semibold'>📢 Simak Momen Seru di Instagram!</p>
                <p className="mb-2">Jangan lewatkan dokumentasi lengkap kompetisi di Instagram <a className='text-blue-500' href='https://www.instagram.com/iitchallenge2024/#'>@iitchallenge2024</a>.</p>

                <p className="mb-4 font-semibold">Mari dukung generasi muda Indonesia untuk terus berinovasi di dunia digital! 💻🚀</p>
            </section>
        </div>
    )
}
export default CodingJuniorWinnersList